<template>
  <modal-base :is-open="isOpen">

    <div
      class="closeLayer"
      @click="cancel"
    ></div>

    <div class="c-popup-body">
      <div class="c-popup-body__inner">

        <div class="c-popup-body__main">
          <div class="c-popup-body__head">
            <p class="c-popup-body__head-title">
              {{ title }}
            </p>
          </div>
          <div class="c-popup-body__file-select">
            <div
              ref="refUploadFileArea"
              draggable="true"
              class="c-popup-body__file-select-area"
              @dragover.prevent="activateFileArea"
              @dragleave.prevent="inactivateFileArea"
              @drop.prevent="selectFileByDragDrop($event)"
            >
              <p class="contents">
                <span class="text">ファイルをドラッグ＆ドロップ</span>
                <span class="text-or">もしくは</span>
              </p>
              <div class="c-button -center button-area">
                <label class="c-button-white -file">
                  <input
                    type="file"
                    ref="refUploadFileInput"
                    :accept="fileType"
                    required
                    @change="selectFileByInput"
                  >
                  <span class="label">ファイルを選択してください</span>
                </label>
              </div>
            </div>
          </div>
          <p
            :class="{'c-popup-body__file-name': true, '-selected': uploadFile}"
          >{{ fileNameTextContext }}</p>
        </div>

        <div class="c-popup-body__footer">
          <div class="btnBlock">
            <a
              href="javascript:void(0);"
              :class="{'c-button-blue -large': true, '-disabled': !uploadFile}"
              @click="upload"
            >
              <span class="label -upload">アップロードする</span>
            </a>
            <div class="c-button -right">
              <a
                href="javascript:void(0);"
                class="c-button-white -cancel"
                @click="cancel"
              >
                <span class="label">キャンセル</span>
              </a>
            </div>
          </div>
        </div>

        <span
          class="c-popup-body__close"
          @click="cancel"
        >
          <span class="c-popup-body__close-inner"></span>
        </span>

      </div>
    </div>

  </modal-base>
</template>

<script setup lang="ts">
  import { ref, computed } from "vue";

  withDefaults(
    defineProps<{
      isOpen?: boolean
      title?: string
      fileType?: string
    }>(),
    {
      isOpen: false,
      title: "Excelアップロード",
      fileType: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  )
  const emit = defineEmits<{
    (e: 'cancel'): void;
    (e: 'upload', value: any): void;
  }>()
  // ファイル選択 Input
  const refUploadFileInput = ref(null)
  // ファイル Drag & Drop エリア
  const refUploadFileArea = ref(null)

  const selectFileMassage = ref("※ファイルを選択すると、「アップロードする」ボタンが押せるようになります。")
  const uploadFile = ref(null)

  const fileNameTextContext = computed(() => {
    return uploadFile.value ? uploadFile.value.name : selectFileMassage.value
  })

  function activateFileArea() {
    refUploadFileArea.value.classList.add("active")
  }

  function inactivateFileArea() {
    refUploadFileArea.value.classList.remove("active")
  }

  /* FileInput からの選択時 */
  function selectFileByInput() {
    uploadFile.value = refUploadFileInput.value.files[0]
  }

  /* Drag & Drop からの選択時 */
  function selectFileByDragDrop(event) {
    uploadFile.value = event.dataTransfer.files[0]
    inactivateFileArea()
  }

  function cancel() {
    clearSelectedUploadFile()
    emit("cancel")
  }

  function upload() {
    const selectedUploadFile = uploadFile.value
    clearSelectedUploadFile()
    emit("upload", selectedUploadFile)
  }

  function clearSelectedUploadFile() {
    uploadFile.value = null
    refUploadFileInput.value.value = null
  }
</script>

<style lang="scss" scoped>
</style>
